import React from 'react';

import UserCreateOverlay from '../components/UserOverlay/UserCreateOverlay';
import UserDetailOverlay from '../components/UserOverlay/UserDetailOverlay';

type Props = {
  mode?: 'create' | 'edit' | 'view';
};

/**
 * Route shell for /settings/create and /settings/edit/:id (see src/Layout.tsx).
 *
 * Creating a user is a two-step wizard with its own header, stepper and footer;
 * looking at or editing an existing one is a plain detail form. They share the
 * drawer and nothing else, so each mode gets its own component instead of one
 * component full of `mode === 'create'` branches.
 */
const UserOverlay: React.FC<Props> = ({ mode = 'create' }) =>
  mode === 'create' ? <UserCreateOverlay /> : <UserDetailOverlay initialMode={mode} />;

export default UserOverlay;
